import { Component, type ReactNode } from "react";
import { Logo } from "./Logo";

interface State {
  err: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { err: null };

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  componentDidCatch(err: Error, info: { componentStack?: string | null }) {
    // Surface to console for production debugging
    // eslint-disable-next-line no-console
    console.error("[8K Brainzr] render crash:", err, info);
  }

  render() {
    if (this.state.err) {
      const e = this.state.err;
      return (
        <div className="fixed inset-0 overflow-auto p-6 font-mono text-[12px]">
          <h1 className="mb-3 flex items-center gap-3">
            <Logo className="h-12 w-auto" />
            <span className="font-display text-[36px] tracking-[-1px] text-danger">— crash</span>
          </h1>
          <p className="text-text-secondary mb-1">
            Something went wrong while rendering. Please share this:
          </p>
          <pre className="bg-surface text-text-primary p-3 rounded-lg whitespace-pre-wrap break-words mb-3">
            {e.name}: {e.message}
            {"\n\n"}
            {e.stack}
          </pre>
          <button
            onClick={() => location.reload()}
            className="px-4 py-2 rounded-pill bg-accent-gold text-canvas text-[13px] uppercase tracking-[0.04em] font-ui font-medium"
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
